import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { authFetch } from "../api";

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    authFetch("/core/dashboard/")
      .then((res) => res.json())
      .then(setStats)
      .catch(() => setError("Failed to load dashboard stats."));
  }, []);

  const cards = stats
    ? [
        { label: "Menu Items", value: stats.menu_items },
        { label: "Active Menu Items", value: stats.active_menu_items },
        { label: "Services", value: stats.services },
        { label: "Portfolio Projects", value: stats.projects },
      ]
    : [];

  // Things waiting for an admin - linked straight to the screen that handles them.
  const attention = stats
    ? [
        { label: "Help requests to review", value: stats.foundation_pending, to: "/admin/pages/foundation/requests" },
        { label: "Help offers to confirm", value: stats.foundation_offers_pending, to: "/admin/pages/foundation/offers" },
        { label: "Open marketplace jobs", value: stats.cowork_open_jobs, to: "/admin/pages/co-work/jobs" },
        { label: "Marketplace members", value: stats.cowork_members, to: "/admin/pages/co-work/members" },
      ]
    : [];

  return (
    <div>
      <h1 className="text-2xl font-bold mb-6">Dashboard</h1>
      {error && <p className="text-red-400 mb-4">{error}</p>}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {cards.map((card) => (
          <div key={card.label} className="bg-navy border border-navy-border rounded-xl p-6">
            <p className="text-3xl font-bold text-accent-light">{card.value}</p>
            <p className="text-sm text-gray-400 mt-1">{card.label}</p>
          </div>
        ))}
      </div>

      {attention.length > 0 && (
        <>
          <h2 className="text-lg font-semibold mt-10 mb-4">Co-Work &amp; Foundation</h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {attention.map((card) => (
              <Link
                key={card.label}
                to={card.to}
                className={`rounded-xl p-6 border transition-colors hover:border-accent-light ${
                  card.value > 0 && card.label.includes("to ") ? "bg-amber-500/10 border-amber-500/40" : "bg-navy border-navy-border"
                }`}
              >
                <p className="text-3xl font-bold text-accent-light">{card.value}</p>
                <p className="text-sm text-gray-400 mt-1">{card.label}</p>
              </Link>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
